export default "/images/05896e72d14964695b6f0b70d6c9b679.avif";